import {alias, createModelSchema} from "serializr";
import {Schema} from "@/common/Schema";

import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {RewardBunch} from "@/modules/redactor/models/reward/RewardBunch";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export class SmartOfferBundleCardBoxBank extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.CARD_BOX_BANK);

        this._currency = null;

        this._reward = null;

        this._product = null;
    }

    get currency() {
        return this._currency;
    }

    set currency(value) {
        this._currency = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }


    get product() {
        return this._product;
    }

    set product(value) {
        this._product = value;
    }


    valid() {
        if (!super.valid()) {
            console.log("cardbox check 1");
            return false;
        }

        if (!CurrencyKindModel.is(this.currency)) {
            console.log("cardbox check 2");
            return false;
        }

        if (!this.reward || this.reward.empty()) {
            console.log("cardbox check 3");
            return false;
        }

        if (!this.product || !RedactorUtils.getProduct(this.product)) {
            console.log("cardbox check 4");
            return false;
        }

        return true;
    }

    empty() {
        if (!this.reward || this.reward.empty()) {
            return true;
        }

        if(!this.product || !RedactorUtils.getProduct(this.product)){
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleCardBoxBank());
        } else if (target instanceof SmartOfferBundleCardBoxBank) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleCardBoxBank, {
    _currency: alias("currency", CurrencyKindModel.schema()),

    _reward: alias("reward", RewardBunch.schema()),

    _product: alias("product", Schema.primitive()),
});
